/**
 * Arabic (Modern Standard) message catalogue. Key set MUST match en.js.
 * Arabic uses all six CLDR plural categories — zero/one/two/few/many/other.
 */
export default {
  // أسماء عناصر التنقل — يجب أن تطابق مفاتيح en.js تمامًا.
  nav: {
    app_gallery: 'معرض التطبيقات',
    generation_studio: 'استوديو التوليد',
    reel_generator: 'مولّد الأفلام القصيرة',
    media_library: 'مكتبة الوسائط',
    creative_studio: 'الاستوديو الإبداعي',
    animation_styles: 'أنماط الرسوم المتحركة',
    brand_elements_presets: 'عناصر العلامة والإعدادات',
    results_variants: 'النتائج والصيغ',
    asset_vault_projects: 'خزانة الأصول والمشاريع',
    orchestration: 'التنسيق',
    workflows: 'سير العمل',
    api_job_status: 'حالة مهام الواجهة البرمجية',
    workflow_editor: 'محرّر سير العمل',
    review_quality: 'المراجعة والجودة',
    review_queue: 'قائمة المراجعة',
    compliance_audit: 'الامتثال والتدقيق',
    models_routing: 'النماذج والتوجيه',
    routing_policies: 'سياسات التوجيه',
    model_registry: 'سجل النماذج',
    administration: 'الإدارة',
    users_roles: 'المستخدمون والأدوار',
    workspaces_quotas: 'مساحات العمل والحصص',
    api_credentials: 'بيانات اعتماد الواجهة البرمجية',
  },
  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    back: 'رجوع',
    next: 'التالي',
    export: 'تصدير',
    download: 'تنزيل',
    language: 'اللغة',
    loading: 'جارٍ التحميل…',
    error: 'حدث خطأ ما',
  },
  studio: {
    title: 'استوديو الإبداع',
    greeting: 'أهلاً بعودتك، {name}',
    prompt: 'صف ما تريد إنشاءه',
    generate: 'إنشاء',
    variations: 'جرّب صيغة أخرى',
  },
  library: {
    title: 'مكتبة الوسائط',
    assetCount: {
      zero: 'لا توجد أصول',
      one: 'أصل واحد',
      two: 'أصلان',
      few: '{count} أصول',
      many: '{count} أصلاً',
      other: '{count} أصل',
    },
  },
  reel: {
    title: 'مولّد المقاطع',
    play: 'تشغيل',
    pause: 'إيقاف مؤقت',
    timeline: 'الخط الزمني',
  },
  review: {
    title: 'المراجعة والاعتماد',
    approve: 'اعتماد',
    reject: 'طلب تعديلات',
  },
  arabic: {
    headline: 'العنوان بالعربية',
    overlayFont: 'خط العنوان',
    promptTranslated: 'تُرجم طلبك العربي إلى الإنجليزية لهذا النموذج',
    originalPrompt: 'الطلب الأصلي (بالعربية)',
    translatedPrompt: 'الطلب المُرسل إلى النموذج',
  },
};
